import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Click buy to mint your NFT.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 2) {
      newMintAmount = 2;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (
    <div class="bg">
      <header class="text-gray-600 body-font">
        <div class="container mx-auto flex flex-wrap px-5 flex-col md:flex-row items-center  justify-between">
          <a class=" title-font font-medium items-center text-gray-900 mb-4 md:mb-0 bg-black rounded-b-2xl pb-4 ">
            <img src="/images/logo.jpeg" alt="" class="h-20 w-20" />
          </a>
          {blockchain.account ? (
            <button class="inline-flex items-center text-red-500 bg-white font-semibold border-0  px-4 py-2  rounded text-base mt-2 md:mt-0">
              {truncate(blockchain.account, 10)}
            </button>
          ) : (
            <button
              onClick={(e) => {
                e.preventDefault();
                dispatch(connect());
                getData();
              }}
              class="inline-flex items-center text-red-500 bg-white font-semibold border-0  px-4 py-2  rounded text-base mt-2 md:mt-0"
            >
              Connect Wallet
            </button>
          )}
        </div>
      </header>
      <div>
        <h1 class="text-4xl text-center font-black text-white tracking-widest">
          Mecha Tigers NFT Collection
        </h1>
      </div>
      <div class="flex justify-center">
        <section class="text-white body-font flex justify-center sm:w-1/2 w-full ">
          <div class="container mx-auto flex justify-center px-5 my-4 md:flex-row flex-col items-center bg-black bg-opacity-20 rounded-md p-4 ">
            <div class=" md:w-1/2 w-full mb-10 md:mb-0">
              <img
                class="object-cover object-center rounded"
                alt="hero"
                src="/images/q.jpeg"
              />
            </div>
            <div class=" md:w-1/2 w-full flex flex-col md:items-start md:text-left items-center text-center px-8">
              <div class="w-full">
                <div class="py-4">
                  <h1 class="text-center text-xl">
                    Cost: {CONFIG.DISPLAY_COST} ETH{" "}
                  </h1>
                </div>
                <hr />
                <p class="text-center py-2 ">
                  Enter the amount you want to mint
                </p>
                <div>
                  <p class="text-center text-xl py-2">Quantity</p>
                  <div class=" bg-red-700 bg-opacity-30 rounded-full p-2">
                    <div class="flex justify-between">
                      {" "}
                      <div class="px-4">
                        {" "}
                        <button
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            decrementMintAmount();
                          }}
                          class="font-bold text-2xl bg-red-900 rounded-full h-8 w-8"
                        >
                          -
                        </button>
                      </div>
                      <div>
                        <h1 class="font-bold text-2xl"> x{mintAmount}</h1>
                      </div>
                      <div class="px-4">
                        {" "}
                        <button
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            incrementMintAmount();
                          }}
                          class="font-bold text-2xl bg-red-900 rounded-full h-8 w-8 "
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <p class="text-center text-xl py-2">Total Cost</p>
                  <div class="font-bold text-2xl justify-center flex bg-red-700 bg-opacity-30 rounded-full p-2">
                    {mintAmount * CONFIG.DISPLAY_COST} ETH
                  </div>
                </div>
                <p class="text-center">{feedback}</p>
              </div>

              <div class="flex justify-center w-full mt-8">
                {blockchain.account ? (
                  <button
                    disabled={claimingNft ? 1 : 0}
                    onClick={(e) => {
                      e.preventDefault();
                      claimNFTs();
                      getData();
                    }}
                    class="text-center  text-red-500 bg-white   border-0 py-2 px-6 rounded text-lg  font-semibold w-full "
                  >
                    <h1 class="text-center">
                      {" "}
                      {claimingNft ? "MINTING" : "MINT"}
                    </h1>
                  </button>
                ) : (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(connect());
                      getData();
                    }}
                    class="text-center  text-red-500 bg-white   border-0 py-2 px-6 rounded text-lg  font-semibold w-full "
                  >
                    <h1 class="text-center"> CONNECT WALLET</h1>
                  </button>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>

      <footer class="text-white bg-black bg-opacity-70  body-font  w-full sm:fixed sm:bottom-0">
        <div class="container px-5 py-2  mx-auto flex items-center sm:flex-row flex-col">
          <a class="flex title-font font-medium items-center md:justify-start justify-center text-white">
            <img src="/images/logo.jpeg" alt="" class="w-32 h-32" />
            <span class="ml-3 text-xl">Mecha Tigers</span>
          </a>
          <p class="text-sm text-white sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4">
            © 2022 Project T —
            <a
              href="https://twitter.com/projecttnft?s=21"
              class="text-white ml-1"
              rel="noopener noreferrer"
              target="_blank"
            >
              @projectnft
            </a>
          </p>
          <span class="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">
            <a
              class="text-white"
              href="https://discord.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              <svg
                fill="#ffffff"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 30 30"
                class="w-5 h-5"
              >
                {" "}
                <path d="M25.12,6.946c-2.424-1.948-6.257-2.278-6.419-2.292c-0.256-0.022-0.499,0.123-0.604,0.357 c-0.004,0.008-0.218,0.629-0.425,1.228c2.817,0.493,4.731,1.587,4.833,1.647c0.478,0.278,0.638,0.891,0.359,1.368 C22.679,9.572,22.344,9.75,22,9.75c-0.171,0-0.343-0.043-0.501-0.135C21.471,9.598,18.663,8,15.002,8 C11.34,8,8.531,9.599,8.503,9.615C8.026,9.892,7.414,9.729,7.137,9.251C6.86,8.775,7.021,8.164,7.497,7.886 c0.102-0.06,2.023-1.158,4.848-1.65c-0.218-0.606-0.438-1.217-0.442-1.225c-0.105-0.235-0.348-0.383-0.604-0.357 c-0.162,0.013-3.995,0.343-6.451,2.318C3.564,8.158,1,15.092,1,21.087c0,0.106,0.027,0.209,0.08,0.301 c1.771,3.11,6.599,3.924,7.699,3.959c0.007,0.001,0.013,0.001,0.019,0.001c0.194,0,0.377-0.093,0.492-0.25l1.19-1.612 c-2.61-0.629-3.99-1.618-4.073-1.679c-0.444-0.327-0.54-0.953-0.213-1.398c0.326-0.443,0.95-0.541,1.394-0.216 C7.625,20.217,10.172,22,15,22c4.847,0,7.387-1.79,7.412-1.808c0.444-0.322,1.07-0.225,1.395,0.221 c0.324,0.444,0.23,1.066-0.212,1.392c-0.083,0.061-1.456,1.048-4.06,1.677l1.175,1.615c0.115,0.158,0.298,0.25,0.492,0.25 c0.007,0,0.013,0,0.019-0.001c1.101-0.035,5.929-0.849,7.699-3.959c0.053-0.092,0.08-0.195,0.08-0.301 C29,15.092,26.436,8.158,25.12,6.946z M11,19c-1.105,0-2-1.119-2-2.5S9.895,14,11,14s2,1.119,2,2.5S12.105,19,11,19z M19,19 c-1.105,0-2-1.119-2-2.5s0.895-2.5,2-2.5s2,1.119,2,2.5S20.105,19,19,19z" />
              </svg>
            </a>
            <a
              class="ml-3 text-white"
              href="https://twitter.com/projecttnft?s=21"
              rel="noopener noreferrer"
              target="_blank"
            >
              <svg
                fill="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                class="w-5 h-5"
                viewBox="0 0 24 24"
              >
                <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
              </svg>
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}

export default App;
